export default [
  'Abruzzenhumk',
  'Abyssinian Sand Terrier (African Hairless)',
  'Affenpinscher',
  'Afghan Hound',
  'Afghan Hound Mix',
  'Africanis',
  'Airedale Terrier',
  'Airedale Terrier Mix',
  'Akbash',
  'Akbash Mix',
  'Akita',
  'Akita Inu',
  'Akita Mix',
  'Alangu Mastiff',
  'Alano Espanol',
  'Alapaha Blue Blood Bulldog',
  'Alaskan Husky',
  'Alaskan Klee Kai',
  'Alaskan Malamute',
  'Alaskan Malamute Mix',
  'Alopekis',
  'Alpine Dachsbracke',
  'American Akita',
  'American Bulldog',
  'American Bully',
  'American Cocker Spaniel',
  'American English Coonhound',
  'American Eskimo Dog',
  'American Eskimo Dog Mix',
  'American Foxhound',
  'American Hairless Terrier',
  'American Indian Dog',
  'American Mastiff',
  'American Pit Bull Terrier',
  'American Staffordshire Terrier',
  'American Staffordshire Terrier Mix',
  'American Staghound',
  'American Water Spaniel',
  'Anatolian Shepherd Dog',
  'Anglo',
  'Appenzell Mountain Dog',
  'Arctic Husky',
  'Ariege Pointer',
  'Ariegeois',
  'Armant',
  'Artois Hound',
  'Arubian Canucu',
  'Australian Bulldog',
  'Australian Cattle Dog',
  'Australian Cattle Dog Mix',
  'Australian Kelpie Terrier',
  'Australian Kelpie Terrier Mix',
  'Australian Koolie',
  'Australian Shepherd',
  'Australian Shepherd Mix',
  'Australian Silky Terrier',
  'Australian Stumpy Tail Cattle Dog',
  'Australian Terrier',
  'Austrian Black and Tan Hound',
  'Austrian Pinscher',
  'Azawakh',
  'Bakharwal Dog',
  'Balkan Hound',
  'Bandog',
  'Banjara Mastiff',
  'Barbet',
  'Basenji',
  'Basenji Mix',
  'Basque Shepherd Dog',
  'Basset Artésien Normand',
  'Basset Bleu de Gascogne',
  'Basset Fauve de Bretagne',
  'Basset Griffon Vendeen',
  'Basset Hound',
  'Basset Hound Mix',
  'Bavarian Mountain Hound',
  'Beagle',
  'Beagle Mix',
  'Bearded Collie',
  'Bearded Collie Mix',
  'Bearded Tibetan Mastiff',
  'Beauceron',
  'Bedlington Terrier',
  'Belgian Griffon',
  'Belgian Malinois',
  'Belgian Malinois Mix',
  'Belgian Shepherd Dog',
  'Belgian Shepherd Dog Mix',
  'Belgian Tervuren',
  'Belgian Tervuren Mix',
  'Bergamasco',
  'Berger Blanc Suisse',
  'Berger des Pyrenees',
  'Berger Picard',
  'Bernese Mountain Dog',
  'Bernese Mountain Dog Mix',
  'Bhotia',
  'Bichon Frise',
  'Bichon Mix',
  'Biewer Terrier',
  'Bisben',
  'Black and Tan Coonhound',
  'Black Norwegian Elkhound',
  'Blackmouth Cur',
  'Blackmouth Cur Mix',
  'Bloodhound',
  'Bloodhound Mix',
  'Blue Lacy',
  'Blue Paul Terrier',
  'Blue Picardy Spaniel',
  'Bluetick Coonhound',
  'Bobtail Mix',
  'Boerboel',
  'Bohemian Shepherd',
  'Bolognese',
  'Bolonka',
  'Borador',
  'Border Collie',
  'Border Collie Mix',
  'Border Terrier',
  'Border Terrier Mix',
  'Borzoi',
  'Borzoi Mix',
  'Bosnian Coarse Haired Hound',
  'Bosnian Mountain Dog',
  'Boston Terrier',
  'Boston Terrier Mix',
  'Bouvier Bernois',
  'Bouvier des Ardennes',
  'Bouvier des Flandres',
  'Bouvier des Flandres Mix',
  'Boxer',
  'Boxer Mix',
  'Boykin Spaniel',
  'Bracco Italiano',
  "Braque d'Auvergne",
  'Braque du Bourbonnais',
  'Braque Francais',
  'Braque Saint-Germain',
  'Brazilian Mastiff',
  'Brazilian Terrier',
  'Briard',
  'Briard Mix',
  'Briquet Griffon Vendeen',
  'Brittany Spaniel',
  'Brittany Spaniel Mix',
  'Broholmer',
  'Brussels Griffon',
  'Brussels Griffon Mix',
  'Bucovina Shepard',
  'Bulgarian Shepherd Dog',
  'Bull Arab',
  'Bull Mastiff',
  'Bull Mastiff Mix',
  'Bull Terrier',
  'Bull Terrier Mix',
  'Bulldog',
  'Bulldog Mix',
  'Bully Kutta',
  'Byelorussian Ovcharka',
  'Ca de Bou',
  'Cabeçudo Boiadeiro',
  'Cairn Terrier',
  'Cairn Terrier Mix',
  'Canaan Dog',
  'Canaan Dog Mix',
  'Canadian Eskimo Dog',
  'Canadian Pointer',
  'Cane Corso',
  'Cane Corso Mix',
  'Canis Panther',
  'Cao da Serra de Aires',
  'Cao de Castro Laboreiro',
  'Cao de Fila da Terceira',
  'Cao de Fila de Sao Miguel',
  'Cao de Gado Transmontano',
  'Cardigan Welsh Corgi',
  'Carlin Pinscher',
  'Carolina Dog',
  'Carpathian Shepherd Dog',
  'Carpatin',
  'Catahoula Bulldog',
  'Catahoula Cur',
  'Catalan Sheepdog',
  'Caucasian Ovcharka',
  'Cavachon',
  'Cavalier King Charles Spaniel',
  'Cavalier King Charles Spaniel Mix',
  'Central Asian Shepherd',
  'Cesky Fousek',
  'Cesky Terrier',
  'Chart Polski',
  'Chesapeake Bay Retriever',
  'Chesapeake Bay Retriever Mix',
  'Chihuahua',
  'Chihuahua Mix',
  'Chilean Fox Terrier',
  'Chindo',
  'Chinese Chongqing Dog',
  'Chinese Crested Dog',
  'Chinese Crested Dog Mix',
  'Chinese Foo Dog',
  'Chinese Shar',
  'Chinook',
  'Chipoo',
  'Chippiparai',
  'Chodsky pes',
  'Chow Chow',
  'Chow Chow Mix',
  'Circassian Orloff Wolfhound',
  "Cirneco dell'Etna",
  'Clumber Spaniel',
  'Clumber Spaniel Mix',
  'Cockapoo',
  'Cocker Spaniel',
  'Cocker Spaniel Mix',
  'Collie',
  'Collie Mix',
  'Combai',
  'Coonhound',
  'Coonhound Mix',
  'Cordoba Fighting Dog',
  'Corgi',
  'Corgi Mix',
  'Coton de Tulear',
  'Coyote',
  'Croatian Mountain Dog',
  'Croatian Sheepdog',
  'Cur',
  'Curly Coated Retriever',
  'Curly Coated Retriever Mix',
  'Cypro Kukur',
  'Czechoslovakian Wolfdog',
  'Dachshund',
  'Dachshund Mix',
  'Dalmatian',
  'Dalmatian Mix',
  'Dandie Dinmont Terrier',
  'Danish Broholmer',
  'Danish/Swedish Farm Dog',
  'Decker Hunting Terrier',
  'Deerhound',
  'Deutsch Drahthaar',
  'Deutsche Bracke',
  'Deutscher Wachtelhund',
  'Dhoki apso',
  'Dingo',
  'Dingo Mix',
  'Doberman Pinscher',
  'Doberman Pinscher Mix',
  'Dogo Argentino',
  'Dogo Argentino Mix',
  'Dogo Cubano',
  'Dogo Guatemalteco',
  'Dogo Sardesco',
  'Dogue de Bordeaux',
  'Dogue de Majorque',
  'Drever',
  'Drotszoru Magyar Vizsla',
  'Dunker',
  'Dutch Partridge (Drentse Patrijshond)',
  'Dutch Shepherd Dog',
  'Dutch Smoushond',
  'East European Shepherd',
  'East Siberian Laika',
  'Elkhound',
  'Elkhound Mix',
  'Elo',
  'English Bull Terrier',
  'English Bulldog',
  'English Cocker Spaniel',
  'English Coonhound',
  'English Foxhound',
  'English Labrador',
  'English Mastiff',
  'English Pointer',
  'English Setter',
  'English Setter Mix',
  'English Shepherd',
  'English Springer Spaniel',
  'English Staffordshire Terrier',
  'English Toy Spaniel',
  'English Toy Terrier',
  'English White Terrier',
  'Entlebucher Mountain Dog/Sennenhund/Cattle Dog',
  'Epagneul Picard',
  'Eskimo Dog',
  'Estonian Hound',
  'Estrela Mountain Dog',
  'Eurasier',
  'Eurohound',
  'Feist',
  'Fell Terrier',
  'Fennec Fox',
  'Field Spaniel',
  'Fila Brasileiro',
  'Finnish Hound',
  'Finnish Lapphund',
  'Finnish Spitz',
  'Finnish Spitz Mix',
  'Flat Coat Retriever',
  'Flat Coat Retriever Mix',
  'Formosan',
  'Formosan Mix',
  'Fox Terrier',
  'Fox Terrier Mix',
  'Foxhound',
  'Foxhound Mix',
  'Francais Blanc et Noir',
  'Francais Blanc et Orange',
  'Francais Tricolore',
  'Franzuskaya Bolonka',
  'French Brittany',
  'French Bulldog',
  'French Bulldog Mix',
  'French Spaniel',
  'Galgo Espanol',
  'Gawii',
  'German Coolie',
  'German Longhaired Pointer',
  'German Pinscher',
  'German Rough',
  'German Shepherd',
  'German Shepherd Mix',
  'German Short Haired Pointer',
  'German Short Haired Pointer Mix',
  'German Spaniel',
  'German Spitz',
  'German Wire Hair Pointer',
  'German Wire Hair Pointer Mix',
  'Giant Schnauzer',
  'Giant Schnauzer Mix',
  'Glen of Imaal Terrier',
  'Golden Mountain Dog',
  'Golden Retriever',
  'Golden Retriever Mix',
  'Goldendoodle',
  'Gonczy Polski',
  'Gordon Setter',
  'Gordon Setter Mix',
  "Gos d'atura",
  'Gran Mastin de Borínquen',
  'Grand Anglo',
  'Grand Basset Griffon Vendeen',
  'Grand Bleu de Gascogne',
  'Grand Gascon Saintongeois',
  'Grand Griffon Vendeen',
  'Gray Fox',
  'Great Dane',
  'Great Dane Mix',
  'Great Pyrenees',
  'Great Pyrenees Mix',
  'Greater Swiss Mountain Dog',
  'Greater Swiss Mountain Dog Mix',
  'Greek Harehound',
  'Greek Sheepdog',
  'Greenland Dog',
  'Greyhound',
  'Greyhound Mix',
  'Griffon Bleu de Gascogne',
  'Griffon Bruxellois',
  'Griffon Fauve de Bretagne',
  'Griffon Mix',
  'Griffon Nivernais',
  'Groenendael',
  'Guatemalan Bull Terrier',
  'Guejae Gae',
  'Gull Dong',
  'Gull Terr',
  'Habibi Bear Dog',
  'Hairless Khala',
  'Haldenstøvare',
  'Hamiltonstovare',
  'Hangin Tree Cowdog',
  'Hanover Hound',
  'Harlequin Pinscher',
  'Harrier',
  'Harrier Mix',
  'Havanese',
  'Havanese Mix',
  'Hawaiian Poi Dog',
  'Heading Dog',
  'Hellenic Hound',
  'Hermes Bulldogge',
  'Himalayan Mastiff',
  'Himalayan Sheepdog',
  'Hokkaido',
  'Hollandse Herder',
  'Hortaya Borzaya',
  'Hound',
  'Hound Mix',
  'Hovawart',
  'Hucul',
  'Hungarian Greyhound',
  'Hungarian Vizsla',
  'Huntaway',
  'Huntaway Mix',
  'Husky',
  'Husky Mix',
  'Hygenhund',
  'Ibizan Hound',
  'Icelandic Sheepdog',
  'Idaho Shag',
  'Indian Bull Terrier',
  'Indian Spitz',
  'Inuit',
  'Irish Bull Terrier',
  'Irish Red and White Setter',
  'Irish Setter',
  'Irish Setter MIx',
  'Irish Soft Coated Wheaten Terrier',
  'Irish Staffordshire Terrier',
  'Irish Terrier',
  'Irish Water Spaniel',
  'Irish Wolfhound',
  'Irish Wolfhound Mix',
  'Istarski Ostrodlaki Gonic',
  'Istrian Sheepdog',
  'Italian Greyhound',
  'Italian Greyhound Mix',
  'Italian Volpino',
  'Jack Russell Terrier',
  'Jack Russell Terrier Mix',
  'Jagdterrier',
  'Jämthund',
  'Japanese Chin',
  'Japanese Chin Mix',
  'Japanese Mastiff (Tosa Inu)',
  'Japanese Spitz',
  'Japanese Terrier',
  'Jindo',
  'Jindo Mix',
  'Jonangi',
  'Kai Ken',
  'Kaikadi',
  'Kangal Dog',
  'Kangaroo Dog',
  'Kanni',
  'Karafuto Ken',
  'Karelian Bear Dog',
  'Karelo',
  'Kars Dog',
  'Keeshond',
  'Keeshond Mix',
  'Kelb',
  'Kerry Beagle',
  'Kerry Blue Terrier',
  'King Shepherd',
  'Kintamani',
  'Kishu',
  'Kombai',
  'Komondor',
  'Kooikerhondje',
  'Koolie',
  'Koolie Mix',
  'Korea Jindo Dog',
  'Korean Mastiff',
  'Korthals Griffon',
  'Kraski Ovcar',
  'Kritikos Ichnilatis',
  'Kromfohrlander',
  'Kuchi',
  'Kunming Dog',
  'Kuvasz',
  'Kyi Leo',
  'Labradoodle',
  'Labrador Mix',
  'Labrador Retriever',
  'Laekenois',
  'Lagotto Romagnolo',
  'Lakeland Terrier',
  'Lancashire Heeler',
  'Landseer',
  'Lapponian herder',
  'Large Munsterlander',
  'Latvian Hound',
  'Leonberger',
  'Leonberger Mix',
  'Leopard Cur',
  'Lhasa Apso',
  'Lhasa Apso Mix',
  'Lithuanian Hound',
  'Llewellin Setter',
  'Longdog',
  'Lottatore Brindisino',
  'Louisiana Catahoula Leopard Dog',
  'Louisiana Catahoula Leopard Dog Mix',
  'Löwchen',
  'Lucas Terrier',
  'Lurcher',
  'Mackenzie River Husky',
  'Magyar Agar',
  'Majestic Tree Hound',
  'Malamute',
  'Maltalier',
  'Maltese',
  'Maltese Mix',
  'Maltipoo',
  'Manchester Terrier',
  'Maremma Sheepdog',
  'Martin Mosa Mastiff',
  'Mastiff',
  'Mastiff Mix',
  'McNab Shepherd',
  'Meliteo Kinidio',
  'Mexican Hairless Dog (Xoloitzcuintli)',
  'Mi-ki',
  'Middle Asian Owtcharka',
  'Miniature Australian Shepherd',
  'Miniature Bull Terrier',
  'Miniature Dachshund',
  'Miniature Fox Terrier',
  'Miniature Pinscher',
  'Miniature Pinscher Mix',
  'Miniature Poodle',
  'Miniature Poodle Mix',
  'Miniature Schnauzer',
  'Miniature Schnauzer Mix',
  'Miniature Siberian Husky',
  'Mioritic',
  'Mittel Spitz',
  'Mix Breed',
  'Mongrel',
  'Moscow Guard dog',
  'Moscow Watchdog',
  'Mountain Burmese',
  'Mountain Cur',
  'Mountain Dog',
  'Mountain Feist',
  'Mucuchies',
  'Mudhol Hound',
  'Mudi',
  'Munsterlander',
  'Native American Indian Dog',
  'Neapolitan Mastiff',
  'Nebolish Mastiff',
  'Neilmut',
  'Nenets Herding Laika',
  'New Guinea Singing Dog',
  'Newfoundland',
  'Newfoundland Mix',
  'Norfolk Terrier',
  'Norrbottenspets',
  'Northeasterly Hauling Laika',
  'Northern Inuit dog',
  'Norwegian Buhund (Sheepdog)',
  'Norwegian Elkhound',
  'Norwegian Lundehund',
  'Norwich Terrier',
  'Norwich Terrier Mix',
  'Nova Scotia Duck Tolling Retriever',
  'Old Danish Pointer',
  'Old English Bulldog',
  'Old English Sheepdog',
  'Old English Sheepdog Mix',
  'Old English Terrier',
  'Otterhound',
  'Otto',
  'Owczarek Podhalanski',
  'Pachon Navarro',
  'Papillon',
  'Papillon Mix',
  'Parson Russell Terrier',
  'Parson Russell Terrier Mix',
  'Pashmi',
  'Pastor Garafiano',
  'Patterdale Terrier',
  'Pekingese',
  'Pekingese Mix',
  'Pembroke Welsh Corgi',
  'Perdiguero de Burgos',
  'Perro Cimarron',
  'Perro de Pastor Mallorquin',
  'Perro de Presa Canario',
  'Perro de Presa Mallorquin',
  'Perro de Toro',
  'Peruvian Hairless Dog',
  'Peruvian Inca Orchid',
  'Petit Basset Griffon Vendeen',
  'Petit Berger',
  'Petit Bleu de Gascogne',
  'Petit Brabancon',
  'Petit Gascon Saintongeois',
  'Phalène',
  'Pharaoh Hound',
  'Pharaoh Hound Mix',
  'Phung San',
  'Picardy Shepherd',
  'Picardy Spaniel',
  'Pig Dog',
  'Pitbull',
  'Pitbull Mix',
  'Plott Hound',
  'Plott Hound Mix',
  'Podenco Andaluz',
  'Podenco Canario',
  'Podenco Galego',
  'Podenco Ibicenco',
  'Pointer',
  'Pointer Mix',
  'Poitevin',
  'Polish Greyhound',
  'Polish Hound',
  'Polish Lowland Sheepdog',
  'Polish Scenthound',
  'Polish Sighthound',
  'Polish Tatra Sheepdog',
  'Pomeranian',
  'Pomeranian Mix',
  'Pont-Audemer Spaniel',
  'Poodle',
  'Poodle Mix',
  'Porcelaine',
  'Portuguese Podengo',
  'Portuguese Pointer',
  'Portuguese Shepherd Dog',
  'Portuguese Water Dog',
  'Portuguese Water Dog Mix',
  'Posavac Hound',
  'Prague Ratter',
  'Pudelpointer',
  'Pug',
  'Pug Mix',
  'Pugnaces Britanniae',
  'Puli',
  'Puli Mix',
  'Pumi',
  'Pungsan',
  'Pyrenean Mastiff',
  'Pyrenean Mountain Dog',
  'Pyrenean Shepherd',
  'Rafeiro do Alentejo',
  'Rajapalayam',
  'Rampur Greyhound',
  'Rat Terrier',
  'Rat Terrier Mix',
  'Ratonero',
  'Ratonero Bodeguero Andaluz',
  'Red Fox',
  'Red Setter',
  'Redbone Coonhound',
  'Retriever',
  'Retriever Mix',
  'Rhodesian Ridgeback',
  'Ridgeback',
  'Ridgeback Mix',
  'Rottweiler',
  'Rottweiler Mix',
  'Rough Collie',
  'Russell Terrier',
  'Russian Black Terrier',
  'Russian Harlequin Hound',
  'Russian Hound',
  'Russian Setter',
  'Russian Spaniel',
  'Russian Toy Terrier',
  'Russian Tsvetnaya Bolonka',
  'Russo',
  'Ryukyu Inu',
  'Saarlooswolfhond',
  'Sabueso Espanol',
  'Sage Koochee',
  'Saint Bernard',
  'Saint Bernard Mix',
  'Sakhalin Husky',
  'Saluki',
  'Saluki Mix',
  'Samoyed',
  'Samoyed Mix',
  'Sanshu',
  'Santal Hound',
  'Sapsali',
  'Sarplaninac',
  'Schapendoes',
  'Schillerstovare',
  'Schipperke',
  'Schipperke Mix',
  'Schnauzer',
  'Schnauzer Mix',
  'Schweizer Laufhund',
  'Schweizer Niederlaufhund',
  'Scottish Deerhound',
  'Scottish Deerhound Mix',
  'Scottish Terrier',
  'Scottish Terrier Mix',
  'Sealyham Terrier',
  'Segugio Italiano',
  'Seppala Siberian Sleddog',
  'Serbian Hound',
  'Serbian Mountain Hound',
  'Serbian Tricolour Hound',
  'Shar Pei',
  'Shar Pei Mix',
  'Sheep Dog',
  'Shepherd Mix',
  'Shetland Sheepdog',
  'Shetland Sheepdog Mix',
  'Shi',
  'Shiba Inu',
  'Shiba Inu Mix',
  'Shih Tzu',
  'Shih Tzu Mix',
  'Shikoku',
  'Shiloh Shepherd Dog',
  'Siberian Husky',
  'Silken Windhound',
  'Silky Terrier',
  'Silky Terrier Mix',
  'Sindh Mastiff',
  'Skye Terrier',
  'Sloughi',
  'Slovak Cuvac',
  'Slovakian Hound',
  'Slovensky Hrubosrsty Stavac',
  'Smalandsstovare',
  'Small Greek Domestic Dog',
  'Small Munsterlander',
  'Smithfield',
  'Smooth Collie',
  'Smooth Fox Terrier',
  'Snowfur Longsnout',
  'South Russian Ovtcharka',
  'Spaniel Mix',
  'Spanish Greyhound',
  'Spanish Mastiff',
  'Spanish Pointer',
  'Spanish Water Dog',
  'Spinone Italiano',
  'Spitz',
  'Spitz Mix',
  'Spoodle',
  'Springer Spaniel',
  'Springer Spaniel Mix',
  'Stabyhoun',
  'Staffordshire Bull Terrier',
  'Staffordshire Mix',
  'Standard Dachshund',
  'Standard Poodle',
  'Standard Schnauzer',
  'Stephens Stock',
  'Styrian Coarse Haired Hound',
  'Sulimov dog',
  'Sussex Spaniel',
  'Swedish Elkhound',
  'Swedish Lapphund',
  'Swedish Vallhund',
  'Swiss Shorthaired Pinscher',
  'Sydney Silkie',
  'Tahltan Bear Dog',
  'Taigan',
  'Tainaker',
  'Taíno Dog',
  'Taiwan Dog',
  'Tamaskan dog',
  'Tasy',
  'Tatra Shepherd Dog',
  'Teddy Roosevelt Terrier',
  'Telomian',
  'Tenterfield Terrier',
  'Terrier',
  'Terrier Mix',
  'Texas Heeler',
  'Thai Bangkaew Dog',
  'Thai Hairless Dog',
  'Thai Ridgeback',
  'Tibetan Kyi Apso',
  'Tibetan Lhasa Apso',
  'Tibetan Mastiff',
  'Tibetan Spaniel',
  'Tibetan Terrier',
  'Tornjak',
  'Toureg Sloughi',
  'Toy Bulldog',
  'Toy Fox Terrier',
  'Toy Manchester Terrier',
  'Toy Poodle',
  'Transylvanian Hound',
  'Treeing Cur',
  'Treeing Feist',
  'Treeing Tennessee Brindle',
  'Treeing Walker Coonhound',
  'Tsvetnaya Bolonka',
  'Turkish Kangal',
  'Tyrolean Hound',
  'Vizsla',
  'Vizsla Mix',
  'Weimaraner',
  'Weimaraner Mix',
  'Welsh Springer Spaniel',
  'Welsh Terrier',
  'West Highland White Terrier',
  'West Highland White Terrier Mix',
  'Wheaten Terrier',
  'Wheaten Terrier Mix',
  'Whippet',
  'Whippet Mix',
  'Wirehaired Pointing Griffon',
  'Wolf',
  'Wolf Mix',
  'Wolfhound Mix',
  'Yorkshire Terrier',
  'Yorkshire Terrier Mix',
]
